import { http, HttpResponse, PathParams } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { apiUrl } from '../apiUrl';
import { composeServerError, otpHandler, validatePasswordInSettingsFlow } from './shared';

const gdprDeleteVerifyPasswordMutation = http.post<PathParams, { password: string }>(
    apiUrl(AccountApiPaths.gdprDeleteVerifyPassword),
    async ({ request }) => {
        const body = await request.json();
        const { password } = body;
        const error = validatePasswordInSettingsFlow(password);
        return error ? composeServerError(request, error) : new HttpResponse();
    }
);

const gdprDeleteVerifyTotpMutation = http.post(apiUrl(AccountApiPaths.gdprDeleteVerifyTotp), otpHandler);
const gdprDeleteUserMutation = http.post(apiUrl(AccountApiPaths.gdprDeleteUser), () => HttpResponse.json());

export const gdprDeleteHandlers = [
    gdprDeleteVerifyPasswordMutation,
    gdprDeleteVerifyTotpMutation,
    gdprDeleteUserMutation
];
